import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface ContractorCompanyDto {
  companyId: string
  companyName: string
  taxId?: string | null
  contactPerson?: string | null
  contactPhone?: string | null
  isActive: boolean
}

export interface ContractorWorkerAdminDto {
  workerId: string
  tenantId: string
  companyId: string
  companyName: string
  firstName: string
  lastName: string
  fullName: string
  idType: string
  nationalId?: string | null
  passportNo?: string | null
  cardNumber?: string | null
  status: string
  createdAt?: string | null
  updatedAt?: string | null
}

export interface ContractorWorkerSearchParams {
  tenantId: string
  search?: string
  companyId?: string
  status?: string
  pageNumber?: number
  pageSize?: number
}

export interface ContractorCompanySearchParams {
  tenantId: string
  search?: string
  pageNumber?: number
  pageSize?: number
}

export interface ContractorWorkerUpsertRequest {
  tenantId: string
  companyId: string
  firstName: string
  lastName: string
  idType: string
  nationalId?: string | null
  passportNo?: string | null
  cardNumber?: string | null
  status?: string | null
}

export async function searchContractorWorkers(
  params: ContractorWorkerSearchParams,
): Promise<PagedResultDto<ContractorWorkerAdminDto>> {
  const response = await axios.get<PagedResultDto<ContractorWorkerAdminDto>>(
    buildUrl("/api/v1/admin/contractor-workers"),
    { params },
  )
  return response.data
}

export async function createContractorWorker(
  payload: ContractorWorkerUpsertRequest,
): Promise<ContractorWorkerAdminDto> {
  const response = await axios.post<ContractorWorkerAdminDto>(
    buildUrl("/api/v1/admin/contractor-workers"),
    payload,
  )
  return response.data
}

export async function updateContractorWorker(
  workerId: string,
  payload: ContractorWorkerUpsertRequest,
): Promise<ContractorWorkerAdminDto> {
  const response = await axios.post<ContractorWorkerAdminDto>(
    buildUrl(`/api/v1/admin/contractor-workers/${workerId}`),
    payload,
  )
  return response.data
}

export async function searchContractorCompanies(
  params: ContractorCompanySearchParams,
): Promise<PagedResultDto<ContractorCompanyDto>> {
  const response = await axios.get<PagedResultDto<ContractorCompanyDto>>(
    buildUrl("/api/v1/contractors/companies"),
    { params },
  )
  return response.data
}
